function ThreeSixty() {
  return (
    <div className="dice-face face--threesixty">
      <span>360</span>
    </div>
  );
}

export default ThreeSixty;
